import { Trans } from "@lingui/react/macro";
import { createFileRoute } from "@tanstack/react-router";

import { AccountSecurityBanner } from "@/components/account/account-security-banner";
import { CalendarAnalyticsClient } from "@/components/account/provider/calendar-analytics-client";

export const Route = createFileRoute("/_authenticated/account/provider/analytics/calendar")({
  component: CalendarAnalyticsRoute,
});

function CalendarAnalyticsRoute() {
  return (
    <div className="space-y-6">
      <header>
        <h1 className="font-display text-foreground text-2xl font-semibold tracking-[-0.02em]">
          <Trans>Calendar analytics</Trans>
        </h1>
        <p className="text-muted-foreground mt-1 text-sm">
          <Trans>Booking funnel, no-show trends, gap analysis and peak-hour heatmap.</Trans>
        </p>
      </header>

      <CalendarAnalyticsClient />

      <AccountSecurityBanner />
    </div>
  );
}
